import { render, staticRenderFns } from "./OrmVehicleLocationReason.vue?vue&type=template&id=5632b656"
import script from "./OrmVehicleLocationReason.vue?vue&type=script&lang=js"
export * from "./OrmVehicleLocationReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports